import React from 'react';
import { Grid, Tooltip, Typography, withStyles } from '@material-ui/core';

const MAX_TOOLTIP_WIDTH = 1100;

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        color: '#f5f5f9',
        maxWidth: MAX_TOOLTIP_WIDTH,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))(Tooltip);

export const CustomTooltip = ({ placement = 'bottom', title, description, imgSrc, children }) => {
    return (
        <HtmlTooltip
            placement={placement}
            interactive={true}
            title={
                <Grid container spacing={6} style={{ padding: 8, width: MAX_TOOLTIP_WIDTH }}>
                    <Grid item xs={6} style={{ display: 'grid', placeContent: 'center' }}>
                        <img style={{ height: 400, width: 400 }} src={imgSrc} />
                    </Grid>
                    <Grid item xs={6} style={{ display: 'grid', placeContent: 'center' , padding:'24px 16px'}}>
                        <Typography variant="h6" gutterBottom>
                            <strong>{title || ''}</strong>
                        </Typography>
                        <div style={{ fontSize: 14 }} dangerouslySetInnerHTML={{ __html: description }} />
                    </Grid>
                </Grid>
            }
        >
            {children ? children : null}
        </HtmlTooltip>
    );
};

export default CustomTooltip;
